/* Velloria premium: yumuşak belirme efekti */
(function () {
  if (window.__vpPremium) return;
  window.__vpPremium = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  function init() {
    var sel = '.vel-section .page-width > *, .vel-card, .vel-trust__item, .card-wrapper, .product__info-wrapper, .product__media-wrapper, .footer__content-top, .vel-head';
    var nodes = document.querySelectorAll(sel);
    if (!nodes.length) return;
    document.documentElement.classList.add('vp-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vp-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n, i) {
      n.classList.add('vp-reveal');
      n.style.transitionDelay = Math.min((i % 4) * 90, 270) + 'ms';
      var r = n.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { requestAnimationFrame(function () { n.classList.add('vp-in'); }); }
      else { io.observe(n); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();